(function ($) {
    var $message = $('.js-alert-message');
    if ($message) {
        setTimeout(function (){
            $message.css('display', 'none');
        }, 2000);
    }

})(jQuery);
